/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * VideoIcon
 */
export default class VideoIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M21.439 18.828A1 1 0 0023 18V6a1 1 0 00-1.561-.828L18 7.003A3 3 0 0015 4H4a3 3 0 00-3 3v10a3 3 0 003 3h11a3 3 0 003-3l3.439 1.828zM21 7.386v9.228l-3.439-2.33A1 1 0 0016 15.11V17a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h11a1 1 0 011 1v1.889a1 1 0 001.561.828L21 7.386z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

